<div class="flex items-center justify-center bg-gray-50 p-4">
  <mat-card class="w-full max-w-md">
    <mat-card-header>
      <mat-card-title>Two-Factor Authentication</mat-card-title>
      <mat-card-subtitle>Verify your identity to continue.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mt-4">
      @if (context) {
        @if (totpHints.length && phoneHints.length) {
          <mat-tab-group>
            @if (totpHints.length) {
              <mat-tab label="Authenticator App">
                <div class="pt-4">
                  <pt-totp-verify
                    [resolver]="context.resolver"
                    [hint]="totpHints[0]"
                    (verified)="onVerified()"
                  />
                </div>
              </mat-tab>
            }
            @if (phoneHints.length) {
              <mat-tab label="Phone / SMS">
                <div class="pt-4">
                  <pt-phone-verify
                    [resolver]="context.resolver"
                    [hint]="phoneHints[0]"
                    (verified)="onVerified()"
                  />
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        } @else {
          @if (totpHints.length) {
            <pt-totp-verify
              [resolver]="context.resolver"
              [hint]="totpHints[0]"
              (verified)="onVerified()"
            />
          }
          @if (phoneHints.length) {
            <pt-phone-verify
              [resolver]="context.resolver"
              [hint]="phoneHints[0]"
              (verified)="onVerified()"
            />
          }
        }
      } @else {
        <div class="flex flex-col gap-4">
          <p class="text-sm text-gray-600">
            No pending verification. Please sign in again.
          </p>
          <button mat-stroked-button (click)="auth.logout()">Go Back</button>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
